import { Injectable } from "@angular/core";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { ITradeDealLookupService } from "../ITradeDealLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export abstract class TradeDealLookupService
  extends BaseLookupService<string, CubiqTS.DealImpl>
  implements ITradeDealLookupService
{
  private _spotReservationMap: object = {};

  constructor() {
    super(CubiqTS.DealImpl);
  }

  mapItem(item: CubiqTS.DealImpl): void {
    if (this.myItemMap.has(this.getItemKey(item))) {
      let oldItem = this.getItem(this.getItemKey(item));
      this.deleteItem(oldItem);
    }

    let itemKey = this.getItemKey(item);

    try {
      if (item.spotDealId != null) {
        let spotReservationId: string = item.spotDealId.toString();
        this._spotReservationMap[spotReservationId] = spotReservationId;
      }
    } catch (e) {
      logger.out.error(`Failed to map spot deal ID for deal ${itemKey}`);
    }

    this.myItemMap.set(itemKey, item);
  }

  getItemKey(item: CubiqTS.DealImpl): string {
    let trade = item as CubiqTS.DealImpl;
    return String((trade.id as CubiqTS.Long).getLowBits());
  }

  getTradeDeal(id: string): CubiqTS.DealImpl {
    let tradeDeal = this.getItem(id) as CubiqTS.DealImpl; //Object.assign(new CubiqTS.DealImpl(), this.getItem(id));
    if (tradeDeal) {
      tradeDeal = Object.assign(new CubiqTS.DealImpl(), tradeDeal);
    }
    return tradeDeal;
  }

  getTradeDealForIds(ids: Array<string>): Array<CubiqTS.DealImpl> {
    let tradeDeals: Array<CubiqTS.DealImpl> = [];
    for (let id of ids) {
      let tradeDeal = this.getItem(id) as CubiqTS.DealImpl;
      if (tradeDeal) {
        tradeDeals.push(Object.assign(new CubiqTS.DealImpl(), tradeDeal));
      }
    }
    return tradeDeals;
  }

  getAllTradeDeals(): Array<CubiqTS.DealImpl> {
    return this.getAll();
  }

  hasSpotReservationDeal(dealId: CubiqTS.Long | string): boolean {
    let result: boolean = false;

    if (dealId != null && dealId.toString != null) {
      let dealIdStr: string = dealId.toString();
      return this._spotReservationMap[dealIdStr] != null;
    }

    return result;
  }

  getAllSpotReservationDealIds(): Array<string> {
    return Object.keys(this._spotReservationMap);
  }
}

@Injectable()
export class LimitClientTradeLookupService extends TradeDealLookupService {}

@Injectable()
export class AlgoClientTradeLookupService extends TradeDealLookupService {}

@Injectable()
export class BMClientTradeLookupService extends TradeDealLookupService {}

@Injectable()
export class NotificationTradeLookupService extends TradeDealLookupService {}
